module.exports = __webpack_public_path__ + "static/media/shopify-home.0408887f.webp";